




import { Component, Vue } from 'vue-property-decorator';
import { getUrlParam } from '@/utils/common';

@Component({
  name: 'OpenJdPaymentSuccess'
})

export default class OpenJdPaymentSuccess extends Vue {
  path = '';

  mounted() {
    this.path = getUrlParam('path');
    this.OpenJdPaymentSuccess();
  }

  private OpenJdPaymentSuccess() {
    const type = {
      appId: 'D913B60EE3B761094A1062224A560D82',
      vapptype: process.env.VUE_APP_DATA_ENV === 'production' ? '1' : '2', // 1-线上版，2-体验版
      path: this.path,
      des: 'vapp',
      category: 'jump'
    };

    const url = `openjdjrapp://com.jd.jrapp/jdminiprogram/open?jrparam=${JSON.stringify({ 'type': type })}&jrlogin=true&jrcontainer=native`;

    console.log('url', url);

    window.location.href = url;
  }
}

